import { Modal, type ModalProps } from '@mantine/core'

import styles from './AppModal.module.scss'

interface AppModalProps extends ModalProps {}

const AppModal = ({ title, classNames, children, ...props }: AppModalProps) => {
  const hasTitle = !!title

  return (
    <Modal
      centered
      padding="xl"
      withCloseButton
      title={title}
      {...props}
      classNames={{
        ...(hasTitle
          ? {}
          : {
              content: styles.content,
              header: styles.header,
              body: styles.body,
            }),
        ...classNames,
      }}
    >
      {children}
    </Modal>
  )
}

export default AppModal
